import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS, OccSearchOrderDocumentResponse, SearchOrderDocumentParams } from '@my-account/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderDocumentApiService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  search(queryParams: SearchOrderDocumentParams): Observable<OccSearchOrderDocumentResponse> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.orderDocuments, {
      queryParams,
    });

    return this.http.get<OccSearchOrderDocumentResponse>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.orderDocuments),
    });
  }

  download(documentId: string): Observable<HttpResponse<Blob>> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.getOrderDocument, {
      urlParams: { documentId },
    });

    return this.http.get(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.getOrderDocument),
      responseType: 'blob',
      observe: 'response',
    });
  }
}
